<style scoped lang="less">
.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;

	.sclectlable {
		margin-right: 20px;
	}
}

.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #f7f7f7;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	// button:last-child {
	// 	background-color: #ff8300;
	// }

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
		color: #333;
		font-weight: 600 !important;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		background-color: #f41127;
	}
}

.addstras {
	.addstrastitle {
		margin-bottom: 30px;
	}
}
</style>
<template>
	<div>
		<titles titlename="训练策略" titlecontent="这里可以看到训练策略一些信息" :mbx="paths"></titles>

		<div class="manageselect">
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.pro_guid" clearable placeholder="请选择专业" @change="getpolist()">
						<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.PR_GUID" clearable placeholder="请选择岗位">
						<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.IL_GUID" clearable placeholder="请选择考核等级">
						<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div><el-input placeholder="请输入训练策略" v-model="pagesobj.sm_title" clearable></el-input></div>
			</div>

			<div class="primarybtn" @click="getresours()"><el-button type="primary" icon="el-icon-search">搜索</el-button></div>
		</div>
		<div class="resourbtn"><el-button @click.stop="addsours" type="primary" size="small" icon="fa fa-plus">添加策略</el-button></div>

		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column type="selection" :resizable="false" width="55"></el-table-column>
							<el-table-column label="策略名称" :resizable="false" prop="PCR_RuleTitle"></el-table-column>
							<el-table-column label="专业" :resizable="false" prop="pro_name"></el-table-column>
							<el-table-column label="所属岗位" :resizable="false" prop="PR_ProfessionalName" width="150">
								<template slot-scope="scope">
									<p style="text-align: center;width: 100%;">{{ scope.row.PR_ProfessionalName }}</p>
								</template>
							</el-table-column>
							<el-table-column label="考核等级" :resizable="false" prop="IL_LevelTitle" width="100"></el-table-column>
							<el-table-column label="状态" :resizable="false" width="150">
								<template slot-scope="scope">
									<div
										:style="{ background: scope.row.PCT_IsState ? '#55ff00' : '#ff0000' }"
										style="line-height: 30px;border-radius: 50px;width: 100px;height: 30px;color: #fff;margin: 0 auto;"
									>
										{{ scope.row.PCT_IsState ? '已启用' : '已禁用' }}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="操作" :resizable="false" fixed="right" width="400px">
								<template slot-scope="scope">
									<el-popconfirm :title="scope.row.PCT_IsState ? '是否停用？' : '是否启用'" @confirm="changeState(scope.row)">
										<el-button slot="reference" plain size="mini" :style="{ 'background-color': scope.row.PCT_IsState ? '#db4437' : '#4de871' }">
											{{ scope.row.PCT_IsState ? '停用' : '启用' }}
										</el-button>
									</el-popconfirm>

									<el-button plain size="mini" @click="editszy(scope.row)" style="background-color: #57b5da;margin: 0 10px;">编辑</el-button>
									<el-popconfirm title="是否删除该条记录？" @confirm="deleteresce(scope.row)">
										<el-button slot="reference" plain size="mini" style="background-color: #ec0f25;">删除</el-button>
									</el-popconfirm>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesobj.pageSize }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>

		<el-dialog title="添加策略" center :visible.sync="dialogVisible" :before-close="handleClose">
			<div class="addstras">
				<div class="addstrastitle">
					策略设置说明：
					管理员可在此界面设置刷题界面的出题数量、出题题型以及每种题型的分值和每次训练时间，学员在模拟训练得前端页面选择了专业、岗位和等级后即可开始对应的试题训练。
					(当所选题型对应的专业、岗位、等级的题库数量不足设定值时，取最大题数出题，计算分值时系统自动按原小计分值重新分配该类型单题分值。)
					<span style="color: red;">相同专业、等级、岗位里面只有一个策略</span>
				</div>
				<div class="addstrascenter">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
						<el-form-item label="专业" prop="CA_GUID">
							<el-select v-model="ruleForm.CA_GUID" placeholder="请选择专业" @change="getpolist()">
								<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="岗位" prop="PR_GUID">
							<el-select v-model="ruleForm.PR_GUID" placeholder="请选择岗位">
								<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="等级" prop="IL_GUID">
							<el-select v-model="ruleForm.IL_GUID" placeholder="请选择等级">
								<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="策略名称" prop="PCR_RuleTitle"><el-input v-model="ruleForm.PCR_RuleTitle" placeholder="请输入名称"></el-input></el-form-item>
						<el-form-item label="训练组卷设定" prop="name">
							<div class="strategy" style="display: flex;align-items: center;">
								<input v-model="singleCount" type="checkbox" name="dxname" id="" />
								<p>单选题</p>
								<input v-model="ruleForm.PCR_SingleCount" class="form-control" style="width: 150px;margin: 0 10px;" maxlength="3" type="number" />
								<p>道题，每道题</p>
								<input v-model="ruleForm.PCR_SingleScore" class="form-control" style="width: 150px;margin: 0 10px;" maxlength="3" type="number" />
								<p>
									分，小计：
									<span style="color: red;">{{ singleCount ? ruleForm.PCR_SingleCount * ruleForm.PCR_SingleScore : 0 }}</span>
									分
								</p>
							</div>
							<div style="display: flex;align-items: center;">
								<input v-model="multiCount" type="checkbox" name="dxname" id="" />
								<p>多选题</p>
								<input v-model="ruleForm.PCR_MultiCount" class="form-control" style="width: 150px;margin: 0 10px;" maxlength="3" type="number" />
								<p>道题，每道题</p>
								<input v-model="ruleForm.PCR_MultiScore" class="form-control" style="width: 150px;margin: 0 10px;" maxlength="3" type="number" />
								<p>
									分，小计：
									<span style="color: red;">{{ multiCount ? ruleForm.PCR_MultiCount * ruleForm.PCR_MultiScore : 0 }}</span>
									分
								</p>
							</div>
							<div style="display: flex;align-items: center;">
								<input v-model="judgeCount" type="checkbox" name="dxname" id="" />
								<p>判断题</p>
								<input v-model="ruleForm.PCR_JudgeCount" class="form-control" style="width: 150px;margin: 0 10px;" maxlength="3" type="number" />
								<p>道题，每道题</p>
								<input v-model="ruleForm.PCR_JudgeScores" class="form-control" style="width: 150px;margin: 0 10px;" maxlength="3" type="number" />
								<p>
									分，小计：
									<span style="color: red;">{{ judgeCount ? ruleForm.PCR_JudgeCount * ruleForm.PCR_JudgeScores : 0 }}</span>
									分
								</p>
							</div>
							<div>
								<p>
									总计：
									<span style="color: red;">{{ allpices }}</span>
									分
								</p>
							</div>
						</el-form-item>
						<el-form-item label="训练耗时设定" prop="PCR_Duration">
							<el-input v-model="ruleForm.PCR_Duration" style="width: 150px;margin-right: 10px;"></el-input>
							分钟
						</el-form-item>
						<el-form-item label="状态" prop="PCT_IsState">
							<el-select v-model="ruleForm.PCT_IsState" placeholder="请选择状态">
								<el-option label="启用" value="1"></el-option>
								<el-option label="禁用" value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
							<el-button @click="resetForm('ruleForm')">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-dialog>

		<el-dialog title="修改策略" center :visible.sync="dialogVisibles" :before-close="handleClose">
			<div class="addstras">
				<div class="addstrastitle">
					策略设置说明：
					管理员可在此界面设置刷题界面的出题数量、出题题型以及每种题型的分值和每次训练时间，学员在模拟训练得前端页面选择了专业、岗位和等级后即可开始对应的试题训练。
					(当所选题型对应的专业、岗位、等级的题库数量不足设定值时，取最大题数出题，计算分值时系统自动按原小计分值重新分配该类型单题分值。)
					<span style="color: red;">相同专业、等级、岗位里面只有一个策略</span>
				</div>
				<div class="addstrascenter">
					<el-form :model="ruleForm" :rules="rules" ref="ruleFormedit" label-width="120px" class="demo-ruleForm">
						<el-form-item label="专业" prop="CA_GUID">
							<el-select v-model="ruleForm.CA_GUID" placeholder="请选择专业" @change="getpolist()">
								<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="岗位" prop="PR_GUID">
							<el-select v-model="ruleForm.PR_GUID" placeholder="请选择岗位">
								<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="等级" prop="IL_GUID">
							<el-select v-model="ruleForm.IL_GUID" placeholder="请选择等级">
								<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="策略名称" prop="PCR_RuleTitle"><el-input v-model="ruleForm.PCR_RuleTitle" placeholder="请输入名称"></el-input></el-form-item>
						<el-form-item label="训练组卷设定" prop="name">
							<div class="strategy" style="display: flex;align-items: center;">
								<input v-model="singleCount" type="checkbox" name="dxname" id="" />
								<p>单选题</p>
								<input v-model="ruleForm.PCR_SingleCount" class="form-control" style="width: 150px;margin: 0 10px;" maxlength="3" type="number" />
								<p>道题，每道题</p>
								<input v-model="ruleForm.PCR_SingleScore" class="form-control" style="width: 150px;margin: 0 10px;" maxlength="3" type="number" />
								<p>
									分，小计：
									<span style="color: red;">{{ singleCount ? ruleForm.PCR_SingleCount * ruleForm.PCR_SingleScore : 0 }}</span>
									分
								</p>
							</div>
							<div style="display: flex;align-items: center;">
								<input v-model="multiCount" type="checkbox" name="dxname" id="" />
								<p>多选题</p>
								<input v-model="ruleForm.PCR_MultiCount" class="form-control" style="width: 150px;margin: 0 10px;" maxlength="3" type="number" />
								<p>道题，每道题</p>
								<input v-model="ruleForm.PCR_MultiScore" class="form-control" style="width: 150px;margin: 0 10px;" maxlength="3" type="number" />
								<p>
									分，小计：
									<span style="color: red;">{{ multiCount ? ruleForm.PCR_MultiCount * ruleForm.PCR_MultiScore : 0 }}</span>
									分
								</p>
							</div>
							<div style="display: flex;align-items: center;">
								<input v-model="judgeCount" type="checkbox" name="dxname" id="" />
								<p>判断题</p>
								<input v-model="ruleForm.PCR_JudgeCount" class="form-control" style="width: 150px;margin: 0 10px;" maxlength="3" type="number" />
								<p>道题，每道题</p>
								<input v-model="ruleForm.PCR_JudgeScores" class="form-control" style="width: 150px;margin: 0 10px;" maxlength="3" type="number" />
								<p>
									分，小计：
									<span style="color: red;">{{ judgeCount ? ruleForm.PCR_JudgeCount * ruleForm.PCR_JudgeScores : 0 }}</span>
									分
								</p>
							</div>
							<div>
								<p>
									总计：
									<span style="color: red;">{{ allpices }}</span>
									分
								</p>
							</div>
						</el-form-item>
						<el-form-item label="训练耗时设定" prop="PCR_Duration">
							<el-input v-model="ruleForm.PCR_Duration" style="width: 150px;margin-right: 10px;"></el-input>
							分钟
						</el-form-item>
						<el-form-item label="状态" prop="PCT_IsState">
							<el-select v-model="ruleForm.PCT_IsState" placeholder="请选择状态">
								<el-option label="启用" value="1"></el-option>
								<el-option label="禁用" value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="editForm('ruleFormedit')">立即修改</el-button>
							<el-button @click="resetForm('ruleFormedit')">重置</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import {
	AddTrainingStrategy,
	GetTrainingStrategyList,
	getGetProfList,
	getPositionList,
	changeGradeGet,
	getGetResourceTypes,
	EnableTrainingStrategy,
	DisableTrainingStrategy,
	DeleteTrainingStrategy,
	TrainingStrategyDetails,
	UpdateTrainingStrategy
} from '@/request/api/homesview/yunhomes/yunhom.js';

import { GetzyProfList } from '@/request/api/mange/mange.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			dialogVisibles: false,
			dialogVisible: false,
			// 标题
			paths: [
				{
					path: '/homesview/testists/questionbank',
					name: '训练策略'
				}
			],
			totalall: 0,
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				sm_title: '',
				smt_guid: '',
				PR_GUID: '',
				PCR_RuleTitle: '',
				IL_GUID: '',
				pro_guid: '',
				PCT_IsState: ''
			},
			tabsnun: 1,
			tableData: [],
			// 获取专业、岗位、资源类型列表
			rtlist: [],
			prolist: [],
			polist: [],
			rtlist: [],
			gradeget: [],
			// 表单
			ruleForm: {
				PCR_RuleTitle: '', // 策略名称
				PR_GUID: '', // 岗位
				IL_GUID: '',
				PCR_Duration: '',
				PCR_Scores: '',
				CA_GUID: '',
				PCR_SingleScore: '',
				PCR_MultiScore: '',
				PCR_JudgeScores: '',
				PCR_SingleCount: '',
				PCR_MultiCount: '',
				PCR_JudgeCount: '',
				PCT_IsState: ''
			},
			singleCount: false,
			multiCount: false,
			judgeCount: false,
			singleScoreall: 0,
			multiScoreall: 0,
			judgeScoresall: 0,
			rules: {
				PCR_RuleTitle: [{ required: true, message: '请输入策略名称', trigger: 'blur' }],
				PR_GUID: [{ required: true, message: '请选择岗位', trigger: 'change' }],
				IL_GUID: [{ required: true, message: '请选择等级', trigger: 'change' }],
				CA_GUID: [{ required: true, message: '请选择专业', trigger: 'change' }],
				PCR_Duration: [{ required: true, message: '请输入时间', trigger: 'blur' }],
				PCT_IsState: [{ required: true, message: '请选择状态', trigger: 'change' }]
			}
		};
	},
	mounted() {
		this.get();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	computed: {
		allpices() {
			let allpices = 0;
			if (this.singleCount) {
				allpices += this.ruleForm.PCR_SingleCount * this.ruleForm.PCR_SingleScore;
			}
			if (this.multiCount) {
				allpices += this.ruleForm.PCR_MultiCount * this.ruleForm.PCR_MultiScore;
			}
			if (this.judgeCount) {
				allpices += this.ruleForm.PCR_JudgeCount * this.ruleForm.PCR_JudgeScores;
			}
			return allpices;
		}
	},
	methods: {
		// 表单
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					// console.log(this.allpices,"获取总分")
					if (this.allpices != 0) {
						this.ruleForm.PCT_IsState = Number(this.ruleForm.PCT_IsState);
						AddTrainingStrategy(this.ruleForm).then(res => {
							if (res.data.code > 0) {
								this.ruleForm = {
									PCR_RuleTitle: '', // 策略名称
									PR_GUID: '', // 岗位
									IL_GUID: '',
									PCR_Duration: '',
									PCR_Scores: '',
									CA_GUID: '',
									PCR_SingleScore: '',
									PCR_MultiScore: '',
									PCR_JudgeScores: '',
									PCR_SingleCount: '',
									PCR_MultiCount: '',
									PCR_JudgeCount: '',
									PCT_IsState: ''
								};
								this.$message.success(res.data.msg);
								this.get();
								this.dialogVisible = false;
							}
						});
					} else {
						this.$message('请勾选题目');
					}
				} else {
					// console.log('error submit!!');
					return false;
				}
			});
		},
		editForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					// console.log(this.allpices,"获取总分")
					if (this.allpices != 0) {
						// "PCR_GUID":""
						this.ruleForm.PCT_IsState = Number(this.ruleForm.PCT_IsState);
						// console.log(this.ruleForm,"进入")
						UpdateTrainingStrategy(this.ruleForm).then(res => {
							if (res.data.code > 0) {
								this.ruleForm = {
									PCR_RuleTitle: '', // 策略名称
									PR_GUID: '', // 岗位
									IL_GUID: '',
									PCR_Duration: '',
									PCR_Scores: '',
									CA_GUID: '',
									PCR_SingleScore: '',
									PCR_MultiScore: '',
									PCR_JudgeScores: '',
									PCR_SingleCount: '',
									PCR_MultiCount: '',
									PCR_JudgeCount: '',
									PCT_IsState: ''
								};
								this.$message.success(res.data.msg);
								this.get();
								this.dialogVisibles = false;
							}
						});
					} else {
						this.$message('请勾选题目');
					}
				} else {
					// console.log('error submit!!');
					return false;
				}
			});
		},
		// 添加
		addsours() {
			this.ruleForm = {
				PCR_RuleTitle: '', // 策略名称
				PR_GUID: '', // 岗位
				IL_GUID: '',
				PCR_Duration: '',
				PCR_Scores: '',
				CA_GUID: '',
				PCR_SingleScore: '',
				PCR_MultiScore: '',
				PCR_JudgeScores: '',
				PCR_SingleCount: '',
				PCR_MultiCount: '',
				PCR_JudgeCount: '',
				PCT_IsState: ''
			};
			this.dialogVisible = true;
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		resetForm(formName) {
			this.ruleForm = {
				PCR_RuleTitle: '', // 策略名称
				PR_GUID: '', // 岗位
				IL_GUID: '',
				PCR_Duration: '',
				PCR_Scores: '',
				CA_GUID: '',
				PCR_SingleScore: '',
				PCR_MultiScore: '',
				PCR_JudgeScores: '',
				PCR_SingleCount: '',
				PCR_MultiCount: '',
				PCR_JudgeCount: '',
				PCT_IsState: ''
			};
			// 重置
			this.$refs[formName].resetFields();
		},
		getprolist() {
			this.prolist = [];

			if (localStorage.getItem('uiguid') == 'f2b9986b57074d2cb2dadd07f6ee62bb') {
				getGetProfList().then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						if (this.pagesobj.pro_guid !== '') {
							this.getpolist();
						}
					}
				});
			} else {
				GetzyProfList(localStorage.getItem('siguid')).then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						if (this.pagesobj.pro_guid !== '') {
							this.getpolist();
						}
					}
				});
			}
		},
		getpolist() {
			let proguid = '';
			if (this.ruleForm.CA_GUID != '') {
				proguid = this.ruleForm.CA_GUID;
			} else {
				proguid = this.pagesobj.pro_guid;
			}
			this.ruleForm.PR_GUID = '';
			this.pagesobj.PR_GUID = '';
			this.polist = [];
			console.log(proguid);

			if (proguid == '') {
				return;
			}

			getPositionList(proguid).then(res => {
				if (res.data.code > 0) {
					this.polist = res.data.data;
				}
			});
		},
		editszy(itm) {
			// 点击编辑 获取详情
			// console.log('编辑',itm)
			let trategy = {
				PCR_GUID: itm.PCR_GUID
			};
			TrainingStrategyDetails(trategy).then(res => {
				if (res.data.code > 0) {
					this.dialogVisibles = true;
					this.ruleForm = res.data.data;
					if (this.ruleForm.PCR_SingleCount > 0) {
						this.singleCount = true;
					}
					if (this.ruleForm.PCR_MultiCount > 0) {
						this.multiCount = true;
					}
					if (this.ruleForm.PCR_JudgeCount > 0) {
						this.judgeCount = true;
					}
					this.ruleForm.PCT_IsState = this.ruleForm.PCT_IsState ? '1' : '0';

					getPositionList(this.ruleForm.CA_GUID).then(res => {
						if (res.data.code > 0) {
							this.polist = res.data.data;
						}
					});
				}
			});
		},
		confirmsh(re, i) {
			let review = {
				LR_GUID: re.LR_GUID,
				LR_State: i
			};

			ResourceReview(review).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.getresours();
				}
			});
		},
		// 删除 启用
		deleteresce(re) {
			let review = {
				PCR_GUID: re.PCR_GUID
			};
			DeleteTrainingStrategy(review).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.get();
				}
			});
		},
		changeState(itm) {
			let state = {
				PCR_GUID: itm.PCR_GUID
			};
			// console.log(itm);
			if (!itm.PCT_IsState) {
				EnableTrainingStrategy(state).then(res => {
					if (res.data.code > 0) {
						this.get();
						this.$message.success(res.data.msg);
					}
				});
			} else {
				DisableTrainingStrategy(state).then(res => {
					if (res.data.code > 0) {
						this.get();
						this.$message.success(res.data.msg);
					}
				});
			}
		},
		changesqx(e) {
			if (e == 0) {
				return '全网公开（所有登录用户）';
			} else if (e == 1) {
				return '只对本院校公开';
			} else if (e == 2) {
				return '全网公开（游客、非注册用户）';
			} else {
				return '私有';
			}
		},
		indexMethod(index) {
			return index + 1;
		},
		changecurr() {},
		get() {
			this.getresours();
			this.getprolist();
			this.getgrads();
			// console.log("请求")
		},
		getgrads() {
			changeGradeGet().then(res => {
				// console.log("获取等级",res)
				this.gradeget = res.data.data;
			});
		},

		getResourceType() {
			getGetResourceTypes().then(res => {
				if (res.data.code > 0) {
					this.rtlist = res.data.data;
				}
			});
		},
		getresours() {
			GetTrainingStrategyList(this.pagesobj).then(res => {
				if (res.data.code > 0) {
					// console.log(res)
					this.tableData = res.data.data.list;
					this.totalall = res.data.data.totalCount;
				}
			});
		}
	},
	components: {
		titles
	}
};
</script>
